<template lang="html">
  <div>
     <div>
        <input type="text" v-digitsonly v-model="longueur" @change="addCredence" placeholder="Longueur de la crédence (en mm)">
        <input type="text" v-digitsonly v-model="largeur" @change="addCredence" placeholder="Largeur de la crédence (en mm)">
     </div>
     <div v-for="(c, index) in credences" id="liste_credence">
        <div class="credence_valeur credence_mesure">
           {{c.lng}} mm x {{c.lrg}} mm x 12mm
        </div>
        <div class="credence_valeur credence_prix">
           {{c.beautifulPrice}}€
        </div>
        <div class="credence_valeur credence_remove">
           <i class="fa fa-trash" @click="removeCredence(index)"></i>
        </div>
    </div>
 </div>
</template>

<script>
import {groups} from '../../assets/configuration.js'
import {JustDigits} from '../../assets/digitsonly.js'
JustDigits()

export default {
  props: ['group'],
  data () {
    return {
      epaisseur: 13,
      longueur: null,
      largeur: null,
      price: 0,
      curGroup: 4,
      groups,
      credences: []
    }
  },
  watch: {
    group () {
      if (this.$store.state.devis[0].group !== this.curGroup) {
        this.setPrice()
        this.curGroup = this.$store.state.devis[0].group
      }
    }
  },
  methods: {
    addCredence () {
      if (this.longueur != null && this.largeur != null && !isNaN(this.longueur) && !isNaN(this.largeur)) {
        var p = this.longueur * this.largeur * this.groups[this.$store.state.devis[0].group].credence
        this.credences.push({lng: this.longueur, lrg: this.largeur, price: p, beautifulPrice: this.beautify(p)})
        this.longueur = null
        this.largeur = null
        this.$store.commit('addPrice', p)
        this.setDevis()
      }
    },
    removeCredence (_index) {
      this.$store.commit('subPrice', this.credences[_index].price)
      this.credences.splice(_index, 1)
      this.setDevis()
    },
    setDevis () {
      this.$store.commit('setDynamicDevis', {id: 7, set: {credences: this.credences}})
    },
    beautify (price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
</script>

<style lang="css" scoped>
#liste_credence .credence_valeur {
   display: inline-block;
}
.credence_mesure {
   width: 59%;
   font-size: 14px;
   font-weight: bold;
}
.credence_prix {
   width: 29%;
   text-align: right;
   font-size: 16px;
   font-weight: bold;
}
.credence_remove i {
   cursor: pointer;
}
.credence_remove {
   width: 9%;
   text-align: center;
   color: #ff0000;
   font-size: 22px;
}

</style>



// WEBPACK FOOTER //
// TailleCredence.vue?467c0b36